import type { ComponentType } from 'preact'
import { text } from '#contract'
import { useT } from '../../i18n/index.ts'
import type { AppIconProps } from '../icons/app-icons.tsx'
import styles from './apps.module.css'

interface AppEmptyStateProps {
  readonly id: string
  readonly icon: ComponentType<AppIconProps>
}

/** What a stub app shows under its header: its icon large, its name, one line. */
export function AppEmptyState({ id, icon: Icon }: AppEmptyStateProps) {
  const t = useT()
  return (
    <div class={styles.empty}>
      <Icon class={styles.emptyIcon} />
      <p class={styles.emptyName}>{t(text(`os.app.${id}.name`))}</p>
      <p class={styles.emptyLine}>{t(text(`os.app.${id}.empty`))}</p>
    </div>
  )
}
